// extracted by mini-css-extract-plugin
export default {"buttonDesign":"Buttons_buttonDesign__YtaxU"};